import { render, staticRenderFns } from "./ImportUserSetting.vue?vue&type=template&id=c2d713d2"
import script from "./ImportUserSetting.vue?vue&type=script&lang=js"
export * from "./ImportUserSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports